import { GridRenderCellParams } from "@mui/x-data-grid";
import { Dayjs } from "dayjs";

import Text from "../atoms/Text";

const DataGridDateCell = (params: GridRenderCellParams<Dayjs>) => {
  return (
    <Text variant="body_small">
      {params.value ? params.value.format("DD/MM/YYYY") : "-"}
    </Text>
  );
};

export default DataGridDateCell;
